import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

export const WindowStepper = ({
  dateFromState,
  onPreviousMonth,
  onNextMonth,
}) => {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="window-stepper">
      <div className="week-stepper-nav">
        <button
          type="button"
          data-button-type="text-white"
          data-icon-only
          aria-label={t("annualPlanner.previousMonth")}
          onClick={onPreviousMonth}
        >
          <SvgIcon src="/img/new-icons/arrow-left.svg" />
        </button>
        <span className="week-stepper-label">
          {moment(dateFromState).format("MMM YYYY")} -{" "}
          {moment(dateFromState).add(11, "months").format("MMM YYYY")}
        </span>
        <button
          type="button"
          data-button-type="text-white"
          data-icon-only
          aria-label={t("annualPlanner.nextMonth")}
          onClick={onNextMonth}
        >
          <SvgIcon src="/img/new-icons/arrow-right.svg" />
        </button>
      </div>
    </div>
  );
};
